import React, {useCallback, useState} from 'react';
import {useTranslation} from 'react-i18next';
import Slider from 'react-slick';

import Loader from 'components/Loader';
import GroupActions from 'components/Builder/GroupActions';
import ModalAddUpdateSession from 'components/Session/ModalAddUpdateSession';

import Array from 'helpers/Array';

import useGroup from 'hooks/useGroup';
import useDomino from 'hooks/useDomino';
import useSession from 'hooks/useSession';
import useConfig from 'hooks/useConfig';
import useColor from 'hooks/useColor';

import 'slick-carousel/slick/slick.css';


function NextArrow(props) {
	const {className, style, onClick} = props;
	return (
		<button
			className={'btn btn-icon btn-icon-only btn-outline-primary ' + className}
			data-glide-dir=">"
			style={style}
			onClick={onClick}
		>
			<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20"
			     fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"
			     strokeLinejoin="round" className="cs-icon cs-icon-chevron-right">
				<path
					d="M7 4L12.6464 9.64645C12.8417 9.84171 12.8417 10.1583 12.6464 10.3536L7 16"></path>
			</svg>
		</button>
	);
}

function PrevArrow(props) {
	const {className, style, onClick} = props;
	return (
		<button
			className={'btn btn-icon btn-icon-only btn-outline-primary ' + className}
			data-glide-dir="<"
			style={style}
			onClick={onClick}
		>
			<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20"
			     fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"
			     strokeLinejoin="round" className="cs-icon cs-icon-chevron-left">
				<path
					d="M13 16L7.35355 10.3536C7.15829 10.1583 7.15829 9.84171 7.35355 9.64645L13 4"></path>
			</svg>
		</button>
	);
}

const settings = {
	className: "slider variable-width",
	dots: false,
	infinite: false,
	centerMode: false,
	slidesToShow: 1,
	slidesToScroll: 1,
	variableWidth: true,
	nextArrow: <NextArrow />,
	prevArrow: <PrevArrow />
};

function Tabs(props) {
	const {t} = useTranslation();

	const {
		setFetchingGroup
	} = props;

	const [open, setOpen] = useState(false);

	const {
		user
	} = useConfig();

	const {
		getCurrentGroup,
		group: currentGroup,
		groupes,
		addGroup
	} = useGroup();

	const {
		palettes
	} = useColor();

	const {
		fetching
	} = useDomino();

	const {
		name,
		session,
		setup
	} = useSession();

	const checkToOpen = useCallback(() => {
		if (user.anonym) {
			alert(t('Tabs.error.connecting'));
			return;
		}
		setOpen(true);
	}, [user]);

	const getTabGroup = (groupData, indexGroup) => {
		let hasTooDomino = false;
		return (
			<div
				className="nav-item"
				role="presentation"
				key={'group' + indexGroup}
			>

				<div className="tooltip--bottom">
					{groupData.detail && groupData.detail.length > 0 && (
						<div className="tooltip-content">
							{Array.chunk(groupData.detail, 2).map((chunk, indexChunk) => {
								return (
									<div className="row" key={'detail' + indexChunk}>
										{chunk.map((groupDetailData, indexGroupDetail) => {
											let maxDomino = false;
											palettes.map((palette) => {
												palette.colors.map((color) => {
													if (color.id === groupDetailData.color.id) {
														maxDomino = color.count;
													}
												})
											});

											if (maxDomino < groupDetailData.count) {
												hasTooDomino = true;
											}
											return (

												<div className={'col-6 line-color colnum' + indexGroupDetail}
												     key={'detail' + indexGroupDetail + indexChunk}>
													<div className={'color-picto color-' + groupDetailData.color.code}
													     style={{
														     backgroundColor: groupDetailData.color.code
													     }} />
													<div
														className={(maxDomino < groupDetailData.count ? 'withSvg' : '')}>
														{groupDetailData.count}
														{maxDomino < groupDetailData.count && (
															<svg
																viewBox="0 0 24 24" width="15" stroke="currentColor"
																strokeWidth="2" fill="none" strokeLinecap="round"
																strokeLinejoin="round"
															>
																<path
																	d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"></path>
																<line x1="12" y1="9" x2="12" y2="13"></line>
																<line x1="12" y1="17" x2="12.01" y2="17"></line>
															</svg>
														)}
													</div>
												</div>
											);
										})}
									</div>
								);
							})}
						</div>
					)}

					<span
						onClick={() => {
							if (currentGroup.id === groupData.group.id) {
								return;
							}
							setFetchingGroup(true);

							if (
								groupData.group &&
								groupData.group.config &&
								groupData.group.config.setup
							) {
								let setupGroup = groupData.group.config.setup;
								if (
									setupGroup.marginHorizontal !== setup.marginHorizontal ||
									setupGroup.marginVertical !== setup.marginVertical ||
									setupGroup.domino.size.width !== setup.domino.size.width ||
									setupGroup.domino.size.height !== setup.domino.size.height ||
									setupGroup.domino.size.thickness !== setup.domino.size.thickness ||
									setupGroup.type !== setup.type
								) {
									let affirm = window.confirm(t('ModalSetting.rebuildGroup'));
									if (affirm) {
										setFetchingGroup(true);
										let params = {...groupData.group.config};
										params.setup.marginHorizontal = setup.marginHorizontal;
										params.setup.marginVertical = setup.marginVertical;
										params.setup.type = setup.type;
										params.setup.domino.size.width = setup.domino.size.width;
										params.setup.domino.size.height = setup.domino.size.height;
										params.setup.domino.size.thickness = setup.domino.size.thickness;
										params.groupId = groupData.group.id;
										params.name = groupData.group.name;
										delete params.width;
										delete params.maxHeight;
										delete params.maxWidth;
										delete params.height;
										addGroup(params);
										return;
									}
								}
							}

							getCurrentGroup(groupData.group);
						}}
						className={'nav-link text-center' + (currentGroup.id === groupData.group.id ? ' done' : '')}
						role="tab"
						data-index="0"
						aria-selected="false"
					>
									<div
										className="mb-1 title d-sm-block">
										{groupData.group.name ? groupData.group.name : '-'}
									</div>
									<div
										className="text-small description d-md-block">
										{hasTooDomino && (
											<svg
												style={{
													marginRight: 5
												}}
												viewBox="0 0 24 24" width="15" stroke="currentColor"
												strokeWidth="2" fill="none" strokeLinecap="round"
												strokeLinejoin="round"
											>
												<path
													d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"></path>
												<line x1="12" y1="9" x2="12" y2="13"></line>
												<line x1="12" y1="17" x2="12.01" y2="17"></line>
											</svg>
										)}
										{groupData.group.count} {t('Sidebar.domino')}{groupData.group.count > 1 ? 's' : ''}
									</div>

									{fetching && currentGroup.id === groupData.group.id && (<Loader />)}
								</span>
				</div>
			</div>
		);
	}
	return (
		<div id="Tabs" className="card mb-5 wizard">
			<ModalAddUpdateSession
				id={session}
				forceOpen={open}
				setForceOpenOpen={setOpen}
			/>

			<div className="card-header border-0 pb-0">
				<div className="settings">
					<div className="name-session">
						{name}
						<svg
							onClick={() => {
								checkToOpen(true);
							}}
							viewBox="0 0 24 24"
							width="15"
							height="15"
							stroke="currentColor"
							strokeWidth="2"
							fill="none"
							strokeLinecap="round"
							strokeLinejoin="round"
						>
							<path d="M12 20h9"></path>
							<path d="M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4L16.5 3.5z"></path>
						</svg>
					</div>
					<div className="tool-session">

					</div>
				</div>
				<div className="wrapper-ul">
					<div className="current-group">
						<GroupActions setFetchingGroup={setFetchingGroup} />
						<div className="current-group-name">
							{groupes && groupes.map((groupData, indexGroup) => {
								if (currentGroup.id === groupData.group.id) {
									return getTabGroup(groupData, indexGroup);
								}
							})}
						</div>
					</div>
					<Slider
						{...settings}
						afterChange={(index) => {

						}}
						className="nav nav-tabs"
						role="tablist"
					>
						{groupes && groupes.map((groupData, indexGroup) => {
							if (currentGroup.id !== groupData.group.id) {
								return getTabGroup(groupData, indexGroup);
							}
						})}
					</Slider>
				</div>
			</div>
		</div>
	);
}

export default Tabs;
